import { IComponent } from '../Interface/Interface';

export const setAmountStepsForCPUComponent = (component: IComponent) => {
  if (component.identifier === 'cpu') {
    component.amountSteps = [1, 2, 4];
  }
};

export const getClosestAmountForInputValue = (
  amountSteps: number[],
  amountIn: number,
  currentAmount = 0
) =>
  amountSteps.reduce((prev, curr) => {
    const cd = Math.abs(curr - amountIn);
    const pd = Math.abs(prev - amountIn);
    return cd < pd
      ? curr
      : cd === pd
      ? amountIn > currentAmount
        ? Math.max(prev, curr)
        : Math.min(prev, curr)
      : prev;
  });
